<template>
  <div style="width: 100%;">
    <el-container>
      <el-aside style="width: 200px;">
        <Menu activeName="2"></Menu>
      </el-aside>
      <el-main
        style="display: flex;flex: 1;flex-direction: column;align-items: center;justify-content: center;padding-top: 100px;height: 100vh;">
        <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;width: 80%;">
          <el-button size="small" type="primary" @click="openInvitation">邀请</el-button>
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="业务员名称">
              <el-autocomplete size="small" class="inline-input" value-key="username" v-model="searchForm.username"
                :fetch-suggestions="usernameSearch" placeholder="请输入客户名称" :trigger-on-focus="false"></el-autocomplete>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input size="small" v-model="searchForm.phone" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="getTeamUser">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table height="400" v-if="!empty" border ref="multipleTable" :data="list" tooltip-effect="dark"
          style="width: 80%;margin: 0 auto;" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="username" label="业务员名称" width="120">
          </el-table-column>
          <el-table-column prop="phone" label="手机号" width="120">
          </el-table-column>
          <el-table-column label="团队管理员" width="120">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.team_admin" @change="changeTeamState(scope.row)" active-color="#13ce66"
                :active-value=1 :inactive-value=0 active-text="是" inactive-text="否">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="register_time" label="注册时间" width="200">
          </el-table-column>
          <el-table-column prop="last_login_time" label="最后登录时间" width="200">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-popconfirm title="是否移除该业务员？" @confirm="moveOutOfTeam(scope.row)">
                <el-button slot="reference" type="text" size="small">移除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-if="!empty" style="margin-top: 30px;" background layout="total,sizes,prev, pager, next,jumper"
          :page-sizes="[10, 20, 50, 100]" :page-size.sync="searchForm.limit" :current-page.sync="searchForm.page"
          @size-change="getTeamUser" @current-change="getTeamUser" :total="total">
        </el-pagination>

        <el-empty description="暂无业务员" v-if="empty"></el-empty>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'
import Common from '@/components/Common.vue'
import { MoveOutOfTeam, Invitation, GetTeamUser, SetTeamAdminUser } from '../api/personnel.js'

export default {
  name: 'Personnel',
  components: { Menu, Common },
  data() {
    return {
      total: 0,
      empty: false,
      searchForm: {
        limit: 10
      },
      list: []
    }
  },
  mounted() {
    this.getTeamUser()
  },
  methods: {
    changeTeamState(row) {
      let params = { user_id: row.id, state: row.team_admin }
      SetTeamAdminUser(params).then(res => {
        if (res.code === 200) {
          this.getTeamUser()
          this.$message.success("设置成功")
        } else {

        }
      })
    },
    handleSelectionChange() {

    },
    usernameSearch(queryString, cb) {
      var list = this.list
      var results = queryString ? list.filter(this.usernameSearchCreateFilter(queryString)) : list
      // 调用 callback 返回建议列表的数据
      console.log(results)
      cb(results)
    },
    phoneNameSelect(item) {
      this.form.username = item.username
    },
    usernameSearchCreateFilter(queryString) {
      return (placeList) => {
        return (placeList.username.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    openInvitation() {
      var that = this
      this.$prompt('请输入业务员手机号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        Invitation({ phone: value }).then(res => {
          if (res.code === 200) {
            that.$notify({
              type: 'success',
              message: '邀请成功',
              offset: 80
            })
            that.getTeamUser()
          } else {
            that.$notify({
              type: 'error',
              message: res.message,
              offset: 80
            })
          }
        })
      }).catch(() => {
      })
    },
    getTeamUser() {
      var that = this
      GetTeamUser(this.searchForm).then(res => {
        if (res.code === 200) {
          that.list = res.data.list
          that.total = res.data.total
          if (that.total === 0) {
            that.empty = true
          }
        } else {
          that.$notify({
            type: 'error',
            message: res.message,
            offset: 80
          })
        }
      })
    },
    moveOutOfTeam(item) {
      var that = this
      MoveOutOfTeam({ user_id: item.id }).then(res => {
        if (res.code === 200) {
          that.$notify({
            type: 'success',
            message: '操作成功',
            offset: 80
          })
          that.getTeamUser()
        } else {
          that.$notify({
            type: 'error',
            message: res.message,
            offset: 80
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.invitation {
  position: fixed;
  right: 50px;
  bottom: 100px;
  padding: 10px;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
</style>



// WEBPACK FOOTER //
// src/views/Personnel.vue